import { cn } from "../../utils";
import { PropsWithClassName } from "../../types/PropsWithClassName";

export function Dot({ className }: PropsWithClassName) {
  return <div className={cn("size-3", className, "rounded-full")} />;
}

export function RedDot({ className }: PropsWithClassName) {
  return <Dot className={cn(className, "bg-[#F04438]")} />;
}

export function StatusDot({
  className,
  isActive,
}: PropsWithClassName<{ isActive: boolean }>) {
  return isActive ? (
    <Dot className={cn(className, "bg-green-600")} />
  ) : (
    <Dot className={cn(className, "bg-gray-500")} />
  );
}

export default Dot;
